"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceItem = void 0;
class InvoiceItem {
    assignationId;
    departureAt;
    title;
    invoiceBaseAmount;
    get baseInvoiceAmountDisplay() {
        return (this.invoiceBaseAmount / 100).toFixed(2);
    }
    baseAmount;
    get baseAmountDisplay() {
        return (this.baseAmount / 100).toFixed(2);
    }
    invoiceVatAmount;
    get invoiceVatAmountDisplay() {
        return (this.invoiceVatAmount / 100).toFixed(2);
    }
    baseVatAmount;
    vatAmount;
    get vatAmountDisplay() {
        return (this.vatAmount / 100).toFixed(2);
    }
    get invoiceAmountDisplay() {
        return ((this.invoiceBaseAmount + this.invoiceVatAmount) / 100).toFixed(2);
    }
    vatPercentage;
}
exports.InvoiceItem = InvoiceItem;
//# sourceMappingURL=InvoiceItem.js.map